import { render, staticRenderFns } from "./Cats.vue?vue&type=template&id=7b2fbf46&scoped=true&"
import script from "./Cats.vue?vue&type=script&lang=js&"
export * from "./Cats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2fbf46",
  null
  
)

export default component.exports